import { initSlider } from '../../_modules/helpers'
import workerHandler from '../workerHandler'

const hydrateTestimonial = (root, content) => {
    const authorNode = root.querySelector('.testimonial__author')
    const textNode = root.querySelector('.testimonial__text')
    const ratingNode = root.querySelector('.testimonial__rating')
    const linkNode = root.querySelector('.testimonial__link')
    const footerNode = root.querySelector('.testimonial__footer')

    const authority = new URL(content.link).hostname.split('.')[1]
    const starsCount = content.stars
    const ratingInnerHTML = `
        <span aria-hidden="true">
            ${'★'.repeat(starsCount)}
        </span>
        <span class="IH">
            ${starsCount} ${starsCount === 1 ? 'star' : 'stars'}
        </span>
    `

    authorNode.innerHTML = content.author
    textNode.innerHTML = content.text
    ratingNode.innerHTML = ratingInnerHTML
    linkNode.setAttribute('href', content.link)
    footerNode.classList.add(`testimonial__footer--${authority}`)
}

export function initMoreReviews() {
    const sliderRoot = document.getElementById('testimonials')
    if (!sliderRoot) return

    const workerCb = (texts) => {
        const testimonialTemplate = sliderRoot.querySelector('[data-testimonials]')
        const testimonialsRoot = testimonialTemplate.parentNode
        const reference = testimonialTemplate.content.cloneNode(true)
        testimonialTemplate.remove()

        texts.forEach(content => {
            const newTestimonial = reference.cloneNode(true)
            hydrateTestimonial(newTestimonial, content)
            testimonialsRoot.appendChild(newTestimonial)
        })

        sliderRoot.removeAttribute('hidden')

        // enable slider
        initSlider(sliderRoot)
    }

    // initiate content hydration
    workerHandler.postMessage('testimonials', workerCb)
}
